import AdminShell, { AdminNavGroup } from "components/adminUi/AdminShell";
import { routes } from "pages/routes";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import {
  AsyncAdminBuildExercise,
  AsyncAdminDashboard,
  AsyncAdminExercise,
  AsyncAdminExerciseList,
  AsyncAdminTag,
  AsyncAdminTagList,
  AsyncContentFolder,
  AsyncCoursePage,
  AsyncEditContentFile,
  AsyncLessonPage,
  AsyncLibrary,
  AsyncLibraryRoot,
} from "./asyncPages";
import RestrictedRoute from "./components/RestrictedRoute";
import SignOut from "./components/SignOut";

// Content admins get the same shell as the full console, scoped to the content
// surfaces. Catalog opens the student-facing library so creators can see
// published content exactly as learners do.
const CONTENT_NAV_GROUPS: AdminNavGroup[] = [
  {
    label: "Content",
    items: [
      { label: "Library", to: routes.admin.contentFolder.path(), glyph: "▦" },
      { label: "Exercises", to: routes.admin.exerciseList.path(), glyph: "✎" },
      { label: "Tags", to: routes.admin.tagList.path(), glyph: "#" },
      { label: "Catalog", to: routes.libraryRoot.path(), glyph: "◎" },
    ],
  },
];

export default function ContentAdminRoutes() {
  const location = useLocation();
  return (
    <Routes key={location.pathname}>
      <Route
        path={routes.root.pattern}
        element={<Navigate to={routes.admin.contentFolder.path()} replace />}
      />

      {/* Authoring screens render inside the shell; the student-facing catalog
          surfaces (/library, /course) stay outside it below. */}
      <Route element={<AdminShell groups={CONTENT_NAV_GROUPS} />}>
        <Route
          path={routes.admin.contentFolder.pattern}
          element={<RestrictedRoute Component={AsyncContentFolder} permissions="admin" />}
        />

        <Route
          path={routes.admin.editContentFile.pattern}
          element={
            <RestrictedRoute Component={AsyncEditContentFile} permissions="admin" />
          }
        />

        <Route
          path={routes.admin.tagDetails.pattern}
          element={<RestrictedRoute Component={AsyncAdminTag} permissions="admin" />}
        />

        <Route
          path={routes.admin.exerciseDetails.pattern}
          element={<RestrictedRoute Component={AsyncAdminExercise} permissions="admin" />}
        />

        <Route
          path={routes.admin.exerciseBuilder.pattern}
          element={
            <RestrictedRoute Component={AsyncAdminBuildExercise} permissions="admin" />
          }
        />

        {/* Direct routes — no legacy AdminDashboardPage chrome (double header). */}
        <Route
          path={routes.admin.exerciseList.pattern}
          element={
            <RestrictedRoute Component={AsyncAdminExerciseList} permissions="admin" />
          }
        />

        <Route
          path={routes.admin.tagList.pattern}
          element={<RestrictedRoute Component={AsyncAdminTagList} permissions="admin" />}
        />

        <Route
          path={routes.admin.root.pattern}
          element={
            <RestrictedRoute Component={AsyncAdminDashboard} permissions="admin" />
          }
        />
      </Route>

      <Route
        path={routes.libraryRoot.pattern}
        element={<RestrictedRoute Component={AsyncLibraryRoot} permissions="admin" />}
      />

      <Route
        path={routes.libraryObject.pattern}
        element={<RestrictedRoute Component={AsyncLibrary} permissions="admin" />}
      />

      <Route
        path={routes.lessonObject.pattern}
        element={<RestrictedRoute Component={AsyncLessonPage} permissions="admin" />}
      />

      <Route
        path={routes.courseObject.pattern}
        element={<RestrictedRoute Component={AsyncCoursePage} permissions="admin" />}
      />

      <Route path={routes.signOut.pattern} element={<SignOut />} />

      <Route path="*" element={<Navigate to={routes.root.path()} replace />} />
    </Routes>
  );
}
